import React, { useEffect, useState } from 'react'
import { Layout, Row, Col, Typography, Button, Card, Input, notification, Spin, Space, Divider, Form, Select, Tooltip } from 'antd';
import { Header } from '../../component/header/header';
import Sidebar from '../../component/siderbar/sidebar';
import { useDispatch } from 'react-redux';

import { EyeOutlined, HistoryOutlined, SearchOutlined } from '@ant-design/icons';

import './dashboard.css'
import AlertCard from '../../component/alertCard/alertCard';
import { getAllEvents } from '../../features/getEvents/getEvents';
import { useHistory } from 'react-router-dom';
import Modal from '../../component/modals/CustomModal';
import CustomModal from '../../component/modals/CustomModal';
import moment from 'moment';
import { blockOptionsAPI } from '../../apiinteraction/apiinteraction';
import Papa from 'papaparse';
import filePath from '../../csvFile/combined.csv';
import { findByTestId } from '@testing-library/react';


function Dashboard() {

    const { Footer, Sider, Content } = Layout;
    const [form] = Form.useForm()
    const { Title } = Typography;
    let a = [1, 2, 3, 4, 5, 6, 7, 5];
    const dispatch = useDispatch();
    const history = useHistory();
    const { Option } = Select;


    const validateMessage = (data) => {
        const args = {
            message: 'Error',
            description:
                `${data?.message}`,
            duration: 5,
        };
        notification.error(args);
    };


    const [ViewHistory, setViewHistory] = useState(false)

    function onClickView() {
        setViewHistory(true)
        console.log('clicked')

        window.scrollTo({
            top: 60000,
            left: 0,
            behavior: 'smooth'
        });
    }

    const [loader, setLoader] = useState(false)

    const [noData, setNoData] = useState(false)

    const [events, setEvents] = useState([])

    const [limit, setLimit] = useState(4)

    const [offset, setOffset] = useState(0)

    const [totalRecords, setTotalRecords] = useState(0)

    const [isVisible, setIsVisible] = useState(false)

    const [queryValues, setQueryValues] = useState({})

    const [csvdata, setCsvData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);
    const [cameraNames, setCameraNames] = useState([]);
    const [filters, setFilters] = useState({
        cameraName: null,
        kpiType: null,
        detectionDate: null,
        isCustom: null,
        validatedEntry: null
    })

    useEffect(() => {

        fetch(filePath)
            .then(response => response.text())
            .then(csvString => {
                Papa.parse(csvString, {
                    header: true,
                    dynamicTyping: true,
                    complete: (result) => {

                        setLoading(true)
                        const parsedData = result.data.map(row => {
                            const filledRow = {};
                            result.meta.fields.forEach(field => {
                                filledRow[field] = row[field] !== undefined ? row[field] : null;
                            });
                            return filledRow;
                        });
                        const updatedCsvData = [...parsedData];
                        updatedCsvData.pop();

                        setCsvData(updatedCsvData);
                        setAllData(parsedData);

                        const uniqueCameraNames = [...new Set(parsedData.map(item => item.cameraName))];
                        setCameraNames(uniqueCameraNames);
                        setLoading(false)

                    },
                });
            })
            .catch(error => console.error('Error fetching the CSV file:', error));
            
    }, [filePath]);

    const setPreviousFilters = () => {

        const { timestamp = null, ...filters } = (JSON.parse(localStorage?.getItem('dashboard-filters')) || {})
        let filtersToSet = {}
        if (timestamp)
            filtersToSet = { ...filters, timestamp: [moment(timestamp[0]), moment(timestamp[1])] }
        else
            filtersToSet = { ...filters }
        setQueryValues({ ...filtersToSet })
        form.setFieldsValue({ ...filtersToSet })

    }
    const onFinish = (values) => {
        if (filters?.cameraName === null && filters?.kpiType === null && filters?.detectionDate === null && filters?.isCustom === null && filters?.validatedEntry === null) {
            setIsVisible(false)
            allData.pop()
            return setCsvData(allData)
        }
        setLoading(true)
        Object.keys(filters).forEach((key) => {
            if (filters[key] == null) delete filters[key]
        })
        let temp = allData

        temp = temp?.filter(item => {
            let isValid = true;

            if (filters?.cameraName) {
                isValid = isValid && item.cameraName?.toLowerCase() === filters.cameraName.toLowerCase();
            }
            if (filters?.kpiType) {
                isValid = isValid && item.kpiType == filters.kpiType;
            }
            if (filters?.detectionDate) {
                isValid = isValid && moment(item?.detectionDate).isSame(filters?.detectionDate);
            }
            if (filters?.isCustom !== undefined) {
                isValid = isValid && item.manualEntry == (filters.isCustom ? 'True' : 'False');
            }
            if (filters?.validatedEntry !== undefined) {
                isValid = isValid && item.validatedEntry == (filters.validatedEntry ? 'True' : 'False');
            }

            return isValid;
        });

        setCsvData(temp)
        setIsVisible(false)
        setLoading(false)

    }


    const clearFilters = () => {
        setFilters({
            cameraName: null,
            kpiType: null,
            detectionDate: null,
            isCustom: null,
            validatedEntry: null
        })
        form.resetFields()
    }


    let modalState = {
        isVisible: isVisible,
        onFinish: onFinish,
        onCancel: () => setIsVisible(false),
        form: form,
        clearFilters: clearFilters,
        setFilters
    }
    const onClickLoadMore = () => {
        setOffset(offset + limit)
    }

    const handleKpiTypeChange = (value) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            kpiType: value
        }));
    };

    const onFinishFilter = () => {
        setLoading(true);

        let filteredData = allData;

        if (filters.kpiType) {
            filteredData = filteredData?.filter(item => item.kpiType === filters.kpiType);
        }
        console.log(filteredData, 'filterdATA')
        setCsvData(filteredData);
        setLoading(false);
    };

    console.log(csvdata)
    return (
        <div>
            <Layout>
                <Header />
                <Layout>
                    <Sidebar currentKey={"1"} />
                    <Content>
                        <Spin spinning={loading}>
                            <div className='dashboard-page'>
                                {/* <Space> */}
                                <Spin className='loader-custom' style={{ display: loader == true ? "block" : "none", minHeight: "80vh" }} spinning={loader} size="large" >
                                    {/* </Space> */}
                                    <div className='dashboard-page-head'>
                                        <div>
                                            <Title level={2} className='dashboard-heading'>Dashboard</Title>
                                            <div className='dashboard-subheading'>
                                                Detection events captured across all cameras
                                            </div>
                                        </div>
                                        <div className='dashboard-count'>
                                            {csvdata?.length || 0} {csvdata?.length === 1 ? 'detection' : 'detections'}
                                        </div>
                                    </div>

                                    <div className='dashboard-filter-bar'>
                                        <div className='dashboard-filter-group'>
                                            <Tooltip title='Detection type'>
                                                <EyeOutlined className='dashboard-filter-icon' />
                                            </Tooltip>
                                            <Select
                                                className='dashboard-filter-select'
                                                onChange={handleKpiTypeChange}
                                                placeholder='All KPIs'
                                                allowClear
                                            >
                                                <Option value="Baggage Detection">Baggage Detection</Option>
                                                <Option value="Number Plate">Number Plate</Option>
                                                <Option value="Face Recognition">Face Recognition</Option>
                                                <Option value="FireSmoke Detection">Fire & Smoke Detection</Option>
                                                <Option value="PPE Detection">PPE Detection</Option>
                                                <Option value="ForeignMaterial Detection">Foreign Material Detection</Option>
                                            </Select>
                                            <Button className='dashboard-filter-btn is-primary' onClick={onFinishFilter}>
                                                Apply
                                            </Button>
                                        </div>

                                        <div className='dashboard-filter-more'>
                                            <Button className='dashboard-filter-btn' onClick={() => setIsVisible(true)}>
                                                More filters
                                                {Object.keys(queryValues).length > 0 && <span className='filter-span' />}
                                            </Button>
                                        </div>
                                        <CustomModal modalState={modalState} cameraNames={cameraNames} />
                                    </div>

                                    {!noData ?
                                        (!loading
                                            ? <Row gutter={[16, 16]}>
                                                {csvdata?.map((data, index) => (
                                                    <Col key={index} sm={24} md={12} lg={6}>
                                                        <AlertCard index={index} data={data} />
                                                    </Col>
                                                ))}
                                            </Row>
                                            : <></>)
                                        :
                                        <div className='dashboard-empty-state'>No Data Found</div>
                                    }


                                    {ViewHistory == true ?
                                        <Card
                                            title="Filter by" extra={<Input className="search-bar-custom" placeholder="Search"
                                                // onKeyDown={test2}
                                                // onChange={(e) => setSearchField(e.target.value)} 
                                                suffix={
                                                    <SearchOutlined style={{ fontSize: '20px' }} />} />}>


                                            <Row>
                                                {a?.map((data, index) => (
                                                    <Col key={index} style={{ padding: '20px' }} sm={24} md={12} lg={6}>
                                                        <AlertCard data={a} />
                                                    </Col>
                                                ))}
                                            </Row>


                                        </Card>
                                        : null
                                    }

                                    {!noData && <div>
                                        {totalRecords > events?.length && <Row style={{ justifyContent: 'center' }}>
                                            <Button type="primary" onClick={onClickLoadMore}>
                                                Load More
                                            </Button>
                                        </Row>}
                                    </div>}

                                </Spin>
                            </div>
                        </Spin>
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}

export default Dashboard
